import type { IconSvgObject } from './types';

const Typescript03Icon: IconSvgObject = [
  ["path", { d: "M10.5 14H12.5M12.5 14H14.5M12.5 14V19M20 14H17V16.5H20V19H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 22H6C4.89543 22 4 21.1046 4 20L4 4C4 2.89543 4.89543 2 6 2H13L20 9V11M19.5 9H14.998C13.8935 9 12.998 8.10457 12.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Typescript03Icon;
